import { useQuery } from '@tanstack/react-query';
import { DemoDayQueryKeys } from '@/services/demo-day/constants';
import { customFetch } from '@/utils/fetch-wrapper';
import Cookies from 'js-cookie';

export type DemoDayListResponse = {
  access: 'none' | 'FOUNDER';
  confidentialityAccepted: boolean;
  date: string;
  description: string;
  shortDescription: string;
  investorsCount: number;
  slugURL: string;
  status: 'UPCOMING' | 'ACTIVE' | 'COMPLETED' | 'ARCHIVED' | 'REGISTRATION_OPEN';
  teamsCount: number;
  title: string;
  approximateStartDate?: string;
  host?: string;
  logoUrl?: string | null;
  supportEmail?: string | null;
};

async function fetcher(): Promise<DemoDayListResponse[]> {
  const isAuthenticated = Boolean(Cookies.get('authToken'));
  const url = `${process.env.DIRECTORY_API_URL}/v1/demo-days`;

  const response = await customFetch(url, { method: 'GET' }, isAuthenticated);

  if (!response?.ok) {
    throw new Error('Failed to fetch demo days list');
  }

  const data: DemoDayListResponse[] = await response.json();

  return data;
}

export function useGetDemoDaysList() {
  return useQuery({
    queryKey: [DemoDayQueryKeys.GET_DEMO_DAYS_LIST],
    queryFn: fetcher,
  });
}
